import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getIncomeIQueueEligibilityChecks } from 'api/Billing';

export const ELIGIBILITY_CHECKS_KEY = 'income-i-queue-eligibility-checks';

export const useIncomeIQueueEligibilityChecks = ({
  params = {},
  options = {},
  dependencies = []
} = {}) => {
  const navigate = useNavigate();
  return useQuery(
    [ELIGIBILITY_CHECKS_KEY, ...dependencies],
    () => getIncomeIQueueEligibilityChecks(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...options
    }
  );
};
